import * as React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import * as styles from './LinkBlock.module.scss';

export type LinkBlockProps = {
    text: React.ReactNode;
};

function LinkBlock({ text }: LinkBlockProps): React.ReactElement {
    return (
        <p className={styles.root}>
            {text}
            <FaChevronRight className={styles.icon} />
        </p>
    );
}

export default LinkBlock;
